// api.ts
import axios from "axios";
import { store } from "index";
import apiUrl from "slices/apiEndpoint";
import { notifyLoganWorkflowError } from "features/productAssistant/events";

const api = axios.create({
  baseURL: apiUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

const publicAuthEndpoints = new Set([
  "/login/login",
  "/login/login-with-password",
  "/login/resendLoginOtp",
  "/login/send-creatPassword-otp",
  "/login/verify-creatPassword-otp",
  "/login/createPassword",
  "/login/verify-otp",
  "/login/verify-google-login",
]);

const getRequestPath = (url = "") => {
  try {
    return new URL(url, window.location.origin).pathname;
  } catch (_error) {
    return url.split("?")[0];
  }
};

// ✅ Request interceptor (auto attach token)
api.interceptors.request.use(
  (config) => {
    const token = store.getState().Login.token;

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);
api.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const status = error?.response?.status;
    const requestPath = getRequestPath(error?.config?.url);
    const isPublicAuthRequest = publicAuthEndpoints.has(requestPath);
    const requestHeaders = error?.config?.headers;
    const hadAuthorizationHeader = Boolean(
      (typeof requestHeaders?.get === "function" && requestHeaders.get("Authorization")) ||
      requestHeaders?.Authorization ||
      requestHeaders?.authorization
    );

    if (status === 401 && hadAuthorizationHeader && !isPublicAuthRequest) {
      localStorage.removeItem("authUser");
      localStorage.removeItem("token");
      localStorage.removeItem("userEmail");
      window.location.href = "/login";
    }
    if (status >= 500) notifyLoganWorkflowError(status);

    return Promise.reject(error);
  }
);
export default api;
